<template>
  <div>
    <v-form ref="permissionForm" v-model="isPermissionFormValid">
      <v-row>
        <v-col cols="12" md="6">
          <v-select
            v-model="newPermission.role"
            @change="checkNewPermissionRoleInput($event)"
            :items="rolesAllowedToSelect"
            label="Perfil"
            :rules="[validations.required]"
            item-text="name"
            item-value="type"
            dense
            outlined
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-autocomplete
            label="Unidade"
            :items="healthUnits"
            item-text="name"
            item-value="id"
            no-data-text="Nenhum resultado encontrado"
            return-object
            dense
            multiple
            outlined
            chips
            :rules="roleCanManageAllUnits ? [] : [validations.required]"
            v-model="newPermission.units"
            :loading="isFetchingUnits"
            :placeholder="roleCanManageAllUnits ? 'Todas' : ''"
            :disabled="roleCanManageAllUnits"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0" small :color="`gray lighten-3`">
                <span class>{{ item.name }}</span>
              </v-chip>
              <span
                v-if="index === 1"
                class="grey--text caption"
              >(+{{ newPermission.units.length - 1 }} unidades)</span>
            </template>
          </v-autocomplete>
          <v-row justify="end">
            <v-btn class="my-1" small @click="$emit('cancel')">Cancelar</v-btn>
            <v-btn
              class="ml-4 my-1"
              small
              color="primary"
              :disabled="!isPermissionFormValid"
              @click="addPermission"
            >Adicionar permissão</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { get, find, map, groupBy, keys, set, head } from 'lodash';
import { validations, apiResponseMixin } from '@/mixins';
import usersService from '@/services/users-service';
import unitsService from '@/services/units-service.js';

const ALL_UNITS_SELECTION = { name: 'Todas', id: null };

export default {
  name: 'UserPermissionsForm',
  props: {
    alreadySelectedRoles: {
      type: Array,
      default: () => []
    }
  },
  mixins: [validations, apiResponseMixin],
  mounted() {
    this.fetchRoles();
    this.fetchUnits();
  },
  data() {
    return {
      isAddingPermission: false,
      newPermission: { units: [] },
      isPermissionFormValid: false,
      roleTypes: [],
      healthUnits: [],
      userPermissions: [],
      isFetchingUnits: false,
    }
  },
  methods: {
    removePermission(permission) {
      const selectedPermissionIndex = this.userPermissions.indexOf(permission);
      this.userPermissions.splice(selectedPermissionIndex, 1);
    },
    parseUserPermissions(userPermissions) {
      const groupedPermissions = groupBy(userPermissions, role => role.role_type);
      const permissionsNames = keys(groupedPermissions).reduce((acc, curr) => set(acc, curr, get(head(groupedPermissions[curr]), 'name')), {})
      const parsedPermissions = keys(groupedPermissions).reduce((acc, curr) => {
        acc.push({ role: curr, units: map(groupedPermissions[curr], 'unit'), name: permissionsNames[curr] });
        return acc;
      }, []);
      this.userPermissions = parsedPermissions;
    },
    fetchRoles() {
      usersService.roleTypes().then(response => {
        const roles = get(response, 'data');
        const roleTypes = keys(roles).reduce((acc, curr) => {
          acc.push({ ...roles[curr], type: curr })
          return acc;
        }, [])
        this.roleTypes = roleTypes;
      }).catch(err => {
        console.log(err)
      })
    },
    checkNewPermissionRoleInput(roleInput) {
      if (this.roleCanManageAllUnits) {
        this.newPermission.units = [];
      } else {
        this.newPermission.units = null;
      }
    },
    async fetchUnits() {
      this.isFetchingUnits = true;
      try {
        const { data } = await unitsService.all({});
        this.healthUnits = data.units;
      } catch (err) {
        console.log(err);
        this.handleApiErrorResponse(err);
      } finally {
        this.isFetchingUnits = false;
      }
    },
    addPermission() {
      if (this.$refs.permissionForm.validate()) {
        this.$emit('newPermission', { ...this.newPermission, name: this.roleName });
        this.newPermission = {};
      }
    }
  },
  computed: {
    roleName() {
      return get(find(this.roleTypes, { type: get(this, 'newPermission.role') }), 'name')
    },
    roleCanManageAllUnits() {
      const roleType = find(this.roleTypes, { type: get(this, 'newPermission.role') })
      return roleType && roleType.force_all_units;
    },
    rolesAllowedToSelect() {
      return this.roleTypes.filter(roleType => !this.alreadySelectedRoles.includes(roleType.type));
    }
  }
}
</script>

<style>
</style>